"use strict";

exports.__esModule = true;
exports.getRandomOwners = void 0;

var _OwnerWidget = _interopRequireDefault(require("./OwnerWidget"));

exports.OwnerWidget = _OwnerWidget.default;

var _OwnerIcon = _interopRequireDefault(require("./OwnerIcon"));

exports.OwnerIcon = _OwnerIcon.default;

var _getRandomOwner = _interopRequireDefault(require("../../resources/functions/getRandomOwner"));

exports.getRandomOwner = _getRandomOwner.default;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const getRandomOwners = (max = 20) => {
  let owners = [];

  for (let i = 0; i < max; i++) {
    const owner = (0, _getRandomOwner.default)();
    owner.uniqueid = "owner-" + i;
    owners.push(owner);
  }

  return owners;
};

exports.getRandomOwners = getRandomOwners;